"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var RepeatConfig = function RepeatConfig(_ref) {
  var fields = _ref.fields;
  var isRepeated = fields.isRepeated,
    repeatInterval = fields.repeatInterval;
  var repeatIntervalValue = repeatInterval.value;
  var repeatIntervalParts = repeatIntervalValue.split(' ').filter(function (item) {
    return item;
  });
  var repeatIntervalNumber = repeatIntervalParts.length >= 2 ? repeatIntervalParts[0] : '';
  var repeatIntervalUnits = repeatIntervalParts.length >= 2 ? repeatIntervalParts[1] : 'month';
  var _useState = (0, _react.useState)(repeatIntervalUnits),
    _useState2 = _slicedToArray(_useState, 2),
    localRepeatUnits = _useState2[0],
    setLocalRepeatUnits = _useState2[1];
  function onRepeatIntervalNumberChange(updatedNumber) {
    if (!updatedNumber) {
      repeatInterval.onChange('');
      return;
    }
    repeatInterval.onChange("".concat(updatedNumber, " ").concat(localRepeatUnits));
  }
  function onRepeatIntervalUnitsChange(updatedUnits) {
    if (repeatIntervalValue) {
      repeatInterval.onChange("".concat(repeatIntervalNumber, " ").concat(updatedUnits));
    }
    setLocalRepeatUnits(updatedUnits);
  }
  var renderIsRepeatedToggle = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].repeatToggleContainer
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: isRepeated,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Is Repeatable",
      optional: true,
      tooltip: "A repeatable data collection wave (DCW) lets users retake a survey. Data from each attempt are saved in the current DCW under distinct timepoints."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: isRepeated.value,
    onChange: function onChange(e) {
      isRepeated.onChange(!isRepeated.value);
    }
  })));
  var renderRepeatInterval = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('form-group', _style["default"].repeatIntervalContainer)
  }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
    label: "Minimum Repeat Interval",
    optional: true,
    tooltip: "Optional interval to enforce between repeats (whole numbers only)."
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fullwidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "number",
    className: "form-control",
    placeholder: "",
    value: repeatIntervalNumber,
    onChange: function onChange(e) {
      onRepeatIntervalNumberChange(e.target.value);
    },
    style: {
      height: '3.9rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
    data: [{
      value: 'month',
      label: 'month(s)'
    }, {
      value: 'week',
      label: 'week(s)'
    }, {
      value: 'day',
      label: 'day(s)'
    }, {
      value: 'hour',
      label: 'hour(s)'
    }, {
      value: 'minute',
      label: 'minute(s)'
    }],
    onChange: function onChange(e) {
      onRepeatIntervalUnitsChange(e.value);
    },
    textField: "label",
    value: localRepeatUnits,
    valueField: "value"
  }))));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].isRepeatedContainer
  }, renderIsRepeatedToggle, isRepeated.value && renderRepeatInterval);
};
var _default = RepeatConfig;
exports["default"] = _default;